export default class userTokenRefreshModel {
    public token?: string;
    public refreshToken?: string;
  
    constructor(data?: unknown) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }
  